<template>
  <div>
    <v-toolbar dark prominent>
      <v-app-bar-nav-icon>
        <v-icon color="blue darken-2" @click="backButton">
          mdi-arrow-left
        </v-icon>
      </v-app-bar-nav-icon>

      <v-col cols="10" md="11" sm="12">
        <v-img src="/img/fantasy_lineups_logo.png" class="logo mx-auto" width="300" contain />
      </v-col>
    </v-toolbar>

    <v-col cols="12" class="mx-auto mt-4 text-center">
      <v-btn-toggle color="#73c603" v-model="sportId" dense mandatory>
        <v-btn :value="1">NBA</v-btn>
        <v-btn :value="2">MLB</v-btn>
        <v-btn :value="3">NHL</v-btn>
        <v-btn :value="4">NFL</v-btn>
      </v-btn-toggle>
    </v-col>

    <v-col cols="12" md="7" class="mx-auto">
      <v-sheet class="ma-5 pa-3" elevation="3" rounded>
        <v-col>
          <strong class="text-h5">Title</strong>
          <v-text-field v-model="title" placeholder="Article title" outlined dense />
        </v-col>

        <v-col>
          <strong class="text-h5">Content</strong>
          <wysiwyg v-model="content" />
        </v-col>

        <v-col>
          <v-btn block color="success" @click="submitArticle">
            {{ editingId ? "Update" : "Submit" }}
          </v-btn>
          <v-btn block text class="mt-2" v-if="editingId" @click="cancelEdit">
            Cancel Edit
          </v-btn>
        </v-col>
      </v-sheet>

      <v-sheet class="ma-5 pa-3" elevation="3" rounded>
        <v-col>
          <strong class="text-h5">Published Articles</strong>
        </v-col>

        <v-col v-if="!articles.length">
          <p class="grey--text mb-0">No articles published for this sport.</p>
        </v-col>

        <v-col v-for="article in articles" :key="article._id">
          <v-card outlined>
            <div class="d-flex align-center justify-space-between pa-2">
              <div class="text-left">
                <div class="font-weight-bold">{{ article.title }}</div>
                <div class="grey--text caption">
                  {{ article.createdAt | UtcToEst }}
                </div>
              </div>
              <div>
                <v-btn icon color="primary" @click="editArticle(article)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="error" @click="removeArticle(article._id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col class="text-center" v-if="hasMore">
          <v-btn text color="primary" @click="fetchPage(page + 1)">
            Load More
          </v-btn>
        </v-col>
      </v-sheet>
    </v-col>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "articleForm",

  data() {
    return {
      sportId: 1,
      title: "",
      content: "",
      editingId: null,
      page: 1,
      hasMore: false,
    };
  },

  computed: {
    ...mapState("userModule", ["articles"]),

    userId() {
      return localStorage.getItem("user");
    },

    author() {
      return localStorage.getItem("userName");
    },
  },

  mounted() {
    this.fetchPage(1);
  },

  watch: {
    sportId() {
      this.cancelEdit();
      this.fetchPage(1);
    },
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },

    async fetchPage(page) {
      this.page = page;
      const res = await this.$store.dispatch("userModule/getArticles", {
        sportId: this.sportId,
        userId: this.userId,
        page,
        limit: 10,
      });
      this.hasMore = !!res?.pagination?.hasNextPage;
    },

    async submitArticle() {
      if (!this.title.trim() || !this.content.trim()) {
        this.$store.dispatch(
          "notification/add",
          { type: "error", message: "Title and content are required !" },
          { root: true }
        );
        return;
      }

      const response = this.editingId
        ? await this.$store.dispatch("userModule/updateArticle", {
            articleId: this.editingId,
            userId: this.userId,
            title: this.title,
            content: this.content,
          })
        : await this.$store.dispatch("userModule/createArticle", {
            sportId: this.sportId,
            title: this.title,
            content: this.content,
            author: this.author,
            userId: this.userId,
          });

      if (response?.success) {
        this.cancelEdit();
        this.fetchPage(1);
      }
    },

    editArticle(article) {
      this.editingId = article._id;
      this.title = article.title;
      this.content = article.content;
    },

    cancelEdit() {
      this.editingId = null;
      this.title = "";
      this.content = "";
    },

    async removeArticle(articleId) {
      if (!confirm("Delete this article?")) return;
      const response = await this.$store.dispatch("userModule/deleteArticle", {
        articleId,
        userId: this.userId,
      });
      if (response?.success) {
        this.fetchPage(1);
      }
    },
  },
};
</script>

<style>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
</style>
